export default __webpack_public_path__ + "static/media/button-plus-deactivate.44e22cf0.svg";